import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const addImagesTwcAdmin = (formData, code, dealerId) =>
  apiActionCreator({
    'endpoint': `/warranties/${code}/${dealerId}`,
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_TWC_WARRANTIES_ADMIN_ATTACHMENTS,
      [
        {
          'type': ActionTypes.ADDED_TWC_WARRANTIES_ADMIN_ATTACHMENTS,
        },
      ],
      [ActionTypes.ADDED_TWC_WARRANTIES_ADMIN_ATTACHMENTS_FAILED, (error) => buildErrorMessage(error)],
    ],
    'microservice': 'form',
    'method': 'POST',
    'data': formData,
  });

export const addWarrantyAdmin = (data = {}, notification, formData) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties?notification=${notification}`,
      'authenticated': true,
      'types': [
        ActionTypes.ADDING_TWC_WARRANTIES_ADMIN,
        [
          (response) => {
            const {code, dealerId} = response.data;
            dispatch(addImagesTwcAdmin(formData, code, dealerId));
            return {
              'type': ActionTypes.ADDED_TWC_WARRANTIES_ADMIN,
            };
          },
          (response) => MessageActions.addMessageBoxInfo('Registro Guardado'),
        ],
        [ActionTypes.ADDED_TWC_WARRANTIES_ADMIN_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'POST',
      'data': data,
    })
  );
};

export const updateWarrantyAdmin = (data = {}, params) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/warranties/admin/${params.code}/${params.dealerId}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_TWC_WARRANTIES_ADMIN,
        [
          ActionTypes.UPDATED_TWC_WARRANTIES_ADMIN,
          (response) => {
            if (response.message) {
              return MessageActions.addMessageBoxInfo(`Registro Actualizado\n ${response.message}`);
            }
            return MessageActions.addMessageBoxInfo('Registro Actualizado');
          },
        ],
        [ActionTypes.UPDATED_TWC_WARRANTIES_ADMIN_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'contentType': 'application/json',
      'method': 'PUT',
      'data': data,
    })
  );
};

export const checkChassisMileage = (chassis, params = {}) =>
  apiActionCreator({
    'endpoint': `/warranties/${chassis}${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.CHECKING_TWC_WARRANTIES_CHASSIS_KM,
      ActionTypes.CHECKED_TWC_WARRANTIES_CHASSIS_KM,
      [
        ActionTypes.CHECKED_TWC_WARRANTIES_CHASSIS_KM_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const clearUpdateWarrantyAdmin = () => {
  return {
    'type': ActionTypes.CLEAR_UPDATE_WARRANTY_ADMIN,
  };
};
